import { Dialog } from "@app/ui";

import type { I18nKey } from "../../lib/language.js";
import { formatChord } from "../../lib/shortcut-chord.js";
import { useI18n } from "../../lib/useI18n.js";
import { useSettingsStore, type ShortcutAction } from "../../stores/settings.store.js";

const LABELS: Array<[action: ShortcutAction, descKey: I18nKey]> = [
  ["newTask", "shortcuts.newTask"],
  ["today", "shortcuts.today"],
  ["priorities", "shortcuts.priorities"],
  ["calNext", "shortcuts.calNext"],
  ["calPrev", "shortcuts.calPrev"],
  ["undo", "shortcuts.undo"],
  ["help", "shortcuts.showThisHelp"],
];

/** Lists the global keyboard shortcuts (live, user-rebound keys). Opened by `?`. */
export function ShortcutsHelp({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { t } = useI18n();
  const shortcuts = useSettingsStore((s) => s.shortcuts);
  return (
    <Dialog open={open} onClose={onClose} title={t("shortcuts.title")}>
      <ul className="flex flex-col gap-2">
        {LABELS.map(([action, descKey]) => (
          <li key={action} className="flex items-center justify-between gap-4 text-sm">
            <span className="text-muted-foreground">{t(descKey)}</span>
            <kbd className="rounded border bg-muted px-2 py-0.5 font-mono text-xs">{formatChord(shortcuts[action])}</kbd>
          </li>
        ))}
        <li className="flex items-center justify-between gap-4 text-sm">
          <span className="text-muted-foreground">{t("common.closeDialog")}</span>
          <kbd className="rounded border bg-muted px-2 py-0.5 font-mono text-xs">Esc</kbd>
        </li>
      </ul>
      <p className="mt-3 text-xs text-muted-foreground">{t("shortcuts.rebindHint")}</p>
    </Dialog>
  );
}
